XA.component.conveyer = (function ($, document) {
    var api = {};
    api.initInstance = function () {

        conveyerCarousel();

        function conveyerCarousel(){
            var conveyerNavigation = '.conveyer .conveyer-navigation > div';
            var conveyerBody = '.conveyer .conveyer-body > div';


            $(conveyerNavigation).slick({
            mobileFirst: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            asNavFor: conveyerBody,
            dots: false,
            arrows: false,
            focusOnSelect: true,
            responsive: [
                {
                breakpoint: 992,
                settings: "unslick"
                },
            ]
            });

            $(conveyerBody).slick({
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: true,
                // fade: true,
                asNavFor: conveyerNavigation,
                responsive: [
                    {
                    breakpoint: 992,
                    settings: "unslick"
                    },
                ]
            });
        }
 

    };

    api.init = function () {
        api.initInstance();
    };
    return api;
})(jQuery, document);
XA.register("conveyer", XA.component.conveyer);